import Typography from "@material-ui/core/Typography";
import React, { FC, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import CampaignCreationSlideContainer from "../../../components/CampaignCreation/CampaignCreationSlideContainer";
import StateProvinceSelectionDasboard from "./components/StateProvinceSelectionDasboard";
import classes from "./StateProvinceSelectionSlide.module.scss";
import { BaseStepComponentProps } from "../../../components/modules/BaseStepper/BaseStepper";
import { ReduxApplicationState } from "../../../types/ReduxTypes/ReduxApplicationState";
import { errorToaster } from "../../../helpers/toasters";
import {
  getGeoTargetOptions,
  setSelectedGeoTargetOptions as setSelectedGeoTargetOptionsToReduxStore,
} from "../../../redux/reducers/campaignToCreate";

const StateProvinceSelectionSlide: FC<BaseStepComponentProps> = ({
  isAttemptingToGoNext,
  setIsAttemptingToGoNext,
  handleNext,
}) => {
  const geoTargetOptions = useSelector((state: ReduxApplicationState) => state.campaignToCreate.geoTargetOptions);
  const isGeoTargetOptionsPending = useSelector((state: ReduxApplicationState) => state.campaignToCreate.isPending);
  const selectedGeoTargetOptionsFromReduxStore = useSelector(
    (state: ReduxApplicationState) => state.campaignToCreate.selectedGeoTargetOptions,
  );

  const [selectedGeoTargetOptions, setSelectedGeoTargetOptions] = useState(selectedGeoTargetOptionsFromReduxStore);

  const dispatch = useDispatch();

  useEffect(() => {
    if (geoTargetOptions.length === 0) {
      dispatch(getGeoTargetOptions());
    }
  }, [dispatch, geoTargetOptions.length]);

  useEffect(() => {
    if (isAttemptingToGoNext) {
      if (selectedGeoTargetOptions.length !== 0) {
        dispatch(
          setSelectedGeoTargetOptionsToReduxStore(
            selectedGeoTargetOptions.filter((geoTargetOption) => !geoTargetOption.includes("_ALL")),
          ),
        );
        handleNext();
        setIsAttemptingToGoNext(false);
      } else {
        errorToaster("Please, select the required regions.", 5000);
        setIsAttemptingToGoNext(false);
      }
    }
  }, [
    dispatch,
    handleNext,
    isAttemptingToGoNext,
    selectedGeoTargetOptions,
    selectedGeoTargetOptions.length,
    setIsAttemptingToGoNext,
  ]);

  return (
    <CampaignCreationSlideContainer heading="Campaign State / Province Selection">
      {isGeoTargetOptionsPending ? (
        <Typography className={classes.loaderLabel}>Please, wait while we get everything in order...</Typography>
      ) : null}

      {!isGeoTargetOptionsPending && geoTargetOptions.length !== 0 ? (
        <StateProvinceSelectionDasboard
          geoTargetOptions={geoTargetOptions}
          selectedGeoTargetOptions={selectedGeoTargetOptions}
          setSelectedGeoTargetOptions={setSelectedGeoTargetOptions}
        />
      ) : null}
    </CampaignCreationSlideContainer>
  );
};

export default StateProvinceSelectionSlide;
